var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13.7578,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19.5234,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7578,
    y: 8,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7578,
    y: 13.7578,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7578,
    y: 19.5234,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5234,
    y: 8,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5234,
    y: 13.7578,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5234,
    y: 19.5234,
    width: 4.48,
    height: 4.48,
    rx: 0.6,
    fill: "#707070"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2);
export default __webpack_public_path__ + "static/media/grid2.1854b24846dc5cc510a1bd92a3134873.svg";
export { ForwardRef as ReactComponent };